module.exports = __webpack_public_path__ + "static/media/darwinian.06a72535.svg";